module.exports = __webpack_public_path__ + "static/media/sass.64f68b22.png";